import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtData } from "@/components/excelVoce/format";

const AZ = { CREATA: "Creata", CREATA_DA_E4: "Creata dal Registro effettivo", MODIFICATA: "Modificata", VERIFICATA: "Verificata", VERIFICA_RIMOSSA: "Verifica rimossa", ELIMINATA: "Eliminata" };
const Val = ({ v }) => (v ? <span className="text-slate-500">quantità {v.quantita} · data {v.data} · {v.verificata ? `verificata da ${v.verificata_da}` : "non verificata"}</span> : null);

export const StoricoMisura = ({ rid, onClose }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/misure/${rid}/storico`).then((r) => setRows(r.data)); }, [rid]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl max-h-[80vh] overflow-y-auto" data-testid="misura-storico-dialog">
        <DialogHeader><DialogTitle>Storico della misura</DialogTitle></DialogHeader>
        {!rows ? <p className="text-sm text-slate-500">Caricamento…</p> : (
          <ul className="space-y-2">{rows.map((h) => (
            <li key={h.id} className="border-b pb-2 text-xs"><div><b>{AZ[h.azione] || h.azione}</b> · {h.autore} · {fmtData(h.data)}</div><Val v={h.dopo} /></li>))}
          </ul>)}
      </DialogContent>
    </Dialog>
  );
};
